// 1. load framework
import Vue from 'vue'

// 2. load 3rd party
// import * as storeJs from 'store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueTheMask from 'vue-the-mask'
import VueCookies from 'vue-cookies'

// 3. load local config 
import router from './config/router'

// 4. load local resource
import i18n from './plugins/i18n'
import store from './plugins/store'
import * as system from './common/function/system'
import * as util from './common/function/util'
import api from './common/function/api'
import { SocketIO } from './common/function/socketIo'
import "./common/filter/filters"
import moment from "moment";

// 5. load local component
import './assets/css/style.scss'
import App from './App'
import Shared from './shared/'

Vue.config.productionTip = false

Vue.prototype.$store = store
Vue.prototype.system = system
Vue.prototype.util = util
Vue.prototype.api = api
Vue.prototype.EventBus = new Vue();
Vue.prototype.$width = system.width;

moment.locale('ko');

Vue.use(VueCookies)
Vue.use(require('vue-shortkey'), { prevent: ['input', 'textarea'] })
Vue.use(ElementUI, { size: 'mini' })
Vue.use(VueTheMask)
Vue.use(Shared)
Vue.use(SocketIO)
Vue.use(router)

// 쿠키 기본 저장시간은 10시간으로 설정
Vue.$cookies.config('10h')
// Vue.$cookies.config('1min') // test

store.dispatch('setSignInStatus', VueCookies.get('signinStatus') || false)
store.dispatch('setToken', VueCookies.get('token') || null)
store.dispatch('setUserData', VueCookies.get('userData') || null)
store.dispatch('setExpireTime', VueCookies.get('expireTime') || null)

router.beforeEach((to, from, next) => {
  if (to.meta.isLogOut) {
    store.dispatch('signOut');
    VueCookies.remove('refreshed');
    next({ path: '/login' })
  }

  if (to.path.startsWith('/sample')) {
    to.meta.noRequireAuth = true;
  }

  if (!to.meta.noRequireAuth) {
    // let token = store.state.sign.token    
    let signinStatusString = VueCookies.get('signinStatus');
    // let signinStatus = storeJs.get('signinStatus') || false 
    let signinStatus = signinStatusString === 'true'? true: false;
    let userData = store.state.auth.userData
    if (signinStatus) {
      // let data = {
      //     'token': token
      // }
      // 페이지 이동시마다 토큰 업데이트
      // api.refreshToken(data).then(res => {
      //     if (res.code === system.OK) {
      //         // 更新
      //         store.dispatch('setToken', res.datum) // 得到token并存储在本地
      //     }
      // })

      if (userData) {
        let path = to.matched[1].path.replace('/', '');
        let authority = store.state.idb.table_user_authority.find(item => item.name === path);
        if (authority) {
          let user_group_id = userData.user_group_id;
          let group = store.state.idb.table_user_group.find(item => item.id === user_group_id);
          if (group) {
            let authorities = group.authorities.map(item => item.user_authority_id);
            if (!authorities.includes(authority.id)) {

              // next({
              //     path: '/login',
              //     query: {redirect: to.fullPath}
              // })
            }
          }
        }

        next()
      } else {
        // api.findUserName({}).then(res => {
        //     if (res.code === system.OK) {
        //         store.dispatch('setUserData', res.datum)
        //         next()
        //     } else {
        //         next()
        //     }
        // })
        next()
      }

    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
